/**
 * @desc 根据状态和sku查询单个产品信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductMasterResponseDto>;
export function request(
  params: API.basics.productSku.byUniqueSkuAndStatus.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productSku/byUnique/skuAndStatus`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
